const HOST = "https://startupof.herokuapp.com";

export default HOST;
